import { format } from 'date-fns'

export const getCasePostedAtString = (date: Date | null) => {
  if (!date) {
    return ''
  }
  return format(date, 'dd/MM/yyyy')
}
